<!-- static content data from lang: site_management -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
      <template v-if="errored">
        <div class="page-not">
          <Notfound />
        </div>
      </template>
      <template v-else>
        <base-header class="pb-6">
          <div class="row align-items-center pb-4">
            <div class="col-lg-12 col-12">
              <h6 class="h2 text-white d-inline-block mb-0">
                {{ lang.label.editPageTitle }}
              </h6>
              <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                <route-bread-crumb></route-bread-crumb>
              </nav>
            </div>
          </div>
        </base-header>
        <div class="container-fluid mt--6">
          <div>
            <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
              <div class="col-md-12">
                <Alert :type="alertMessage ? alertMessage.type : ''" dismissible
                  v-if="alertMessage && alertMessage.type">
                  <span class="alert-inner--text">{{ alertMessage.message }} </span>
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </Alert>
                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                  <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="row">
                          <div class="col-lg-6">
                            <base-input :label="lang.label.companyName" name="company name" rules="required|max:50"
                              labelClasses="form-control-label asterisk-mark">
                              <el-select v-model="model.companyName" autocomplete="off"
                                :placeholder="lang.label.selectCompany" filterable :disabled="isCompanyAdmin">
                                <el-option v-for="(option, index) in companyName" :key="index" :label="option.Name"
                                  :value="option.ID"></el-option>
                              </el-select>
                            </base-input>
                          </div>
                          <div class="col-md-6">
                            <base-input :label="lang.label.siteName" name="site name" rules="required"
                              autocomplete="off" v-model="model.siteName"
                              labelClasses="form-control-label asterisk-mark"></base-input>
                          </div>
                          <div class="col-md-6">
                            <base-input :label="lang.label.modeOfCommunication"
                              labelClasses="form-control-label asterisk-mark" name="communication mode"
                              :rules="{ required: true }">
                              <b-form-group class="mb-0">
                                <b-form-radio-group id="radio-group" v-model="model.mode" autocomplete="off"
                                  :options="communicationModes" name="radio-options"></b-form-radio-group>
                              </b-form-group>
                            </base-input>
                          </div>
                          <div class="col-md-6">
                            <label>&nbsp;</label>
                            <base-input name="auto approve">
                              <div>
                                <b-form-group>
                                  <b-form-checkbox-group id="approve" v-model="checked" :options="approve" name="roles"
                                    aria-label="auto approve"></b-form-checkbox-group>
                                </b-form-group>
                              </div>
                            </base-input>
                          </div>
                          <div class="col-md-6">
                            <base-input label="Start Date/Time must be before X hours" name="Start Date/Time"
                              rules="numeric" v-model="model.hours" autocomplete="off"
                              @input="checkHours($event)"></base-input>
                          </div>
                          <div class="col-md-6">
                            <base-input :label="lang.label.covidSafety" labelClasses="form-control-label asterisk-mark"
                              name="covid safety option" :rules="{ required: true }">
                              <b-form-group class="mb-0">
                                <b-form-radio-group id="covidSafety-radio-group" v-model="model.covidSafety"
                                  autocomplete="off" :options="covidSafetyOptions"
                                  name="covidSafety-radio-options"></b-form-radio-group>
                              </b-form-group>
                            </base-input>
                          </div>
                          <div class="col-md-6">
                            <base-input :label="lang.label.frequencyWeek" name="frequency week" :rules="{
                              required: true,
                              regex:
                                /^(0|[1-9]?[0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/,
                            }" autocomplete="off" v-model="model.frequencyWeek"
                              labelClasses="form-control-label asterisk-mark"></base-input>
                          </div>
                          <div class="col-md-12 mt-3">
                            <!-- Work Types Section -->
                            <div class="work-types-section card mt-4 mb-4">
                              <div class="card-header border border-solid border-primary">
                                <h3 class="text-primary mb-0">Department Management</h3>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <!-- Add Work Type Form -->
                                  <div class="col-md-6 border-right">
                                    <h4 class="mb-4">Add New Department</h4>
                                    <div class="work-type-form p-3 border rounded">
                                      <div class="row">
                                        <!-- Work Type Input -->
                                        <div class="col-md-12 mb-3">
                                          <base-input :label="'Add ' + lang.label.departmentTypes" name="workTypes"
                                            autocomplete="off" v-model="departmentName"
                                            labelClasses="form-control-label asterisk-mark"></base-input>
                                        </div>
                                        <!-- Add Button -->
                                        <div class="col-12">
                                          <button type="button" @click="addDepartment"
                                            class="btn btn-primary btn-block">
                                            <i class="fas fa-plus-circle mr-2"></i>Add Department
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Department Table -->
                                  <div class="col-md-6">
                                    <h3>Departments</h3>
                                    <div v-for="(department, depIndex) in departments" :key="depIndex" class="mb-3">
                                      <!-- Department Header -->
                                      <div class="card">
                                        <div class="card-header d-flex justify-content-between align-items-center">
                                          <h5 class="mb-0">
                                            <span v-if="!department.editing">{{ department.name }}</span>
                                            <input v-else type="text" v-model="department.name" class="form-control"
                                              placeholder="Enter department name" />
                                          </h5>
                                          <div>
                                            <button type="button" v-if="department.editing"
                                              class="btn btn-outline-success btn-sm"
                                              @click="saveDepartment(depIndex, department.id)">
                                              Save
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm"
                                              @click="removeDepartment(department, depIndex)">
                                              Delete
                                            </button>
                                            <button type="button" class="btn btn-sm btn-primary"
                                              @click="toggleDepartment(depIndex)">
                                              {{ department.expanded ? "Collapse" : "Expand" }}
                                            </button>
                                          </div>
                                        </div>

                                        <!-- Department Content -->
                                        <div v-if="department.expanded" class="card-body">
                                          <!-- Approver Levels -->
                                          <div v-for="(level, index) in approverLevels" :key="level.key" class="mb-3">
                                            <template
                                              v-if="index === 0 || validate(depIndex, approverLevels[index - 1].keyName)">
                                              <h6>{{ level.label }}</h6>

                                              <!-- Dropdown for IDs -->
                                              <el-select v-model="department[level.key].ids" class="flex-grow-1 mb-3"
                                                placeholder="Select approvers" multiple filterable
                                                @change="handleApproverSelection(depIndex, level.key)">
                                                <el-option v-for="option in getApproversNameByCompany" :key="option.ID"
                                                  :label="option.Name" :value="option.ID"></el-option>
                                              </el-select>

                                              <!-- Add Email Button -->
                                              <button type="button" class="btn btn-outline-secondary btn-sm"
                                                @click="openApproverModal(depIndex, level.keyName, index)">
                                                Add Email
                                              </button>

                                              <div v-for="(data, emailDataIndex) in department[level.keyName]"
                                                :key="'email-' + emailDataIndex" class="d-flex align-items-center mb-2">
                                                <span v-if="data.Password"> Email: {{ data.EmailAddress }} <button
                                                    type="button" class="btn btn-outline-danger btn-sm ml-2"
                                                    @click="removeEmail(depIndex, level.keyName, emailDataIndex)">
                                                    Delete
                                                  </button>
                                                </span>
                                              </div>
                                            </template>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 mt-3">
                            <!-- Work Types Section -->
                            <div class="work-types-section card mt-4 mb-4">
                              <div class="card-header border border-solid border-primary">
                                <h3 class="text-primary mb-0">Work Types Management</h3>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <!-- Add Work Type Form -->
                                  <div class="col-md-6 border-right">
                                    <h4 class="mb-4">Add New Work Type</h4>
                                    <div class="work-type-form p-3 border rounded">
                                      <div class="row">
                                        <!-- Work Type Input -->
                                        <div class="col-md-12 mb-3">
                                          <base-input :label="lang.label.workTypes" name="workTypes" autocomplete="off"
                                            v-model="newWorkType" labelClasses="form-control-label asterisk-mark">
                                          </base-input>
                                        </div>

                                        <!-- Work Permit Template Input -->
                                        <div class="col-md-12 mb-3">
                                          <base-input :label="'Add ' + lang.label.workPermit" name="workTypes"
                                            autocomplete="off" labelClasses="form-control-label asterisk-mark">
                                            <el-input v-model="work_permit_template" type="textarea" :rows="4"
                                              :placeholder="'Enter work permit template'" resize="vertical"
                                              class="custom-textarea">
                                            </el-input>
                                          </base-input>
                                        </div>

                                        <!-- Required Documents Select -->
                                        <div class="col-md-12 mb-3">
                                          <base-input :label="lang.label.requiredDocuments" name="company name"
                                            labelClasses="form-control-label asterisk-mark">
                                            <el-select 
                                              v-model="documentName" 
                                              autocomplete="off"
                                              placeholder="Type and press Enter to add document" 
                                              filterable 
                                              multiple 
                                              class="w-100"
                                              default-first-option 
                                              value-key="id"
                                              @keyup.enter.native="handleEnterPress"
                                              >
                                              <!-- @change="handleDocumentSelection" -->
                                              <el-option 
                                                v-for="doc in requiredDocument" 
                                                :key="doc.id" 
                                                :label="doc.name"
                                                :value="doc"
                                              >
                                                {{ doc.name }}
                                              </el-option>
                                            </el-select>
                                          </base-input>

                                        </div>

                                        <!-- Add Button -->
                                        <div class="col-12">
                                          <button type="button" @click="addWorkType" class="btn btn-primary btn-block">
                                            <i class="fas fa-plus-circle mr-2"></i>Add Work Type
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Work Types Table -->
                                  <div class="col-md-6">
                                    <h4 class="mb-4">Existing Work Types</h4>
                                    <div class="work-types-table">
                                      <b-table :items="workTypes" striped hover responsive class="border">
                                        <template #cell(documentName)="data">
                                          <div class="d-flex flex-wrap gap-1">
                                            <template v-if="data.item.documentName && data.item.documentName.length">
                                              <el-tag v-for="(doc, index) in data.item.documentName" :key="index"
                                                size="small" type="info" class="mr-1 mb-1">
                                                {{ doc.name || doc }}
                                              </el-tag>
                                            </template>
                                            <template v-else>
                                              <el-tag size="small" type="info">N/A</el-tag>
                                            </template>
                                          </div>
                                        </template>
                                        <template #cell(name)="data">
                                          <div class="d-flex justify-content-between align-items-center">
                                            <strong>{{ data.item.name }}</strong>
                                          </div>
                                        </template>
                                        <template #cell(actions)="data">
                                          <div class="">
                                            <b-button size="sm" variant="info"
                                              @click="showEditModal(data.item, data.index)" class="mr-2">
                                              <i class="fas fa-edit"></i>
                                            </b-button>
                                            <b-button size="sm" variant="danger" @click="showDeleteModal(data)">
                                              <i class="fas fa-trash-alt"></i>
                                            </b-button>
                                          </div>
                                        </template>
                                      </b-table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <b-modal id="editWorkTypeModal" title="Edit Work Type" @cancel="closeEditModal"
                              @ok="confirmEditWorkType">
                              <div>
                                <b-form-group :label="'Edit ' + lang.label.workTypes" label-for="editWorkTypeInput">
                                  <b-form-input id="editWorkTypeInput" v-model="editWorkTypeInput"
                                    placeholder="Enter work type name">
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group :label="'Edit ' + lang.label.workPermit"
                                  label-for="edit_work_permit_template">
                                  <b-form-input id="edit_work_permit_template" v-model="edit_work_permit_template"
                                    placeholder="Edit work permit template">
                                  </b-form-input>
                                </b-form-group>

                                <base-input :label="lang.label.requiredDocuments" name="documents"
                                  labelClasses="form-control-label asterisk-mark">
                                  <!-- Display existing documents as chips -->
                                  <div class="selected-documents mb-2">
                                    <el-tag v-for="(doc, index) in editdocuments" :key="index" closable
                                      class="mr-1 mb-1" @close="removeDocument(index)">
                                      {{ doc.name || doc }}
                                    </el-tag>
                                  </div>

                                  <!-- Input for new documents -->
                                  <el-select 
                                    v-model="documentInput" 
                                    autocomplete="off"
                                    placeholder="Type and press Enter to add document" 
                                    filterable 
                                    multiple 
                                    class="w-100"
                                    default-first-option 
                                    value-key="name"
                                    @keyup.enter.native="handleEditEnterPress"
                                    >
                                    <!-- @change="handleDocumentSelection" -->
                                    <!-- Show both required documents and custom entries -->
                                    <el-option 
                                      v-for="doc in allDocuments" 
                                      :key="doc.id || doc.name" 
                                      :label="doc.name || doc"
                                      :value="doc"
                                    >
                                      {{ doc.name || doc }}
                                    </el-option>
                                  </el-select>
                                </base-input>

                              </div>
                            </b-modal>

                            <!-- Delete Work Type Modal -->
                            <b-modal id="deleteWorkTypeModal" title="Delete Work Type" @cancel="closeDeleteModal"
                              @ok="deleteWorkType">
                              <p>Are you sure you want to delete this work type?</p>
                            </b-modal>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="text-right mb-3">
                      <base-button type="primary" native-type="submit">{{
                        lang.label.buttons.save
                        }}</base-button>
                      <base-button type="danger" @click="$router.push({ name: 'siteManagementList' })">{{
                        lang.label.buttons.cancel
                        }}</base-button>
                    </div>
                  </form>
                </validation-observer>
                <el-dialog :visible.sync="modalVisible" title="Add Approver Details">
                  <form @submit.prevent="saveApproverDetails">
                    <div class="mb-3">
                      <label class="form-label">Name</label>
                      <input v-model="modalData.Name" type="text" class="form-control" placeholder="Enter name"
                        required />
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input v-model="modalData.EmailAddress" type="email" class="form-control"
                        placeholder="Enter email" required />
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Password</label>
                      <input v-model="modalData.Password" type="password" class="form-control"
                        placeholder="Enter password" required />
                    </div>
                    <div class="d-flex justify-content-end">
                      <button type="button" class="btn btn-secondary me-2" @click="modalVisible = false">Cancel</button>
                      <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                  </form>
                </el-dialog>
              </div>
            </card>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Alert from "@/components/BaseAlert.vue";
import { Select, Option, Dialog, Tag } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { mapGetters } from "vuex";
import Notfound from "@/views/GeneralViews/NotFoundPage.vue";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Tag.name]: Tag,
    'el-dialog': Dialog,
    RouteBreadCrumb,
    Alert,
    Notfound,
  },
  data() {
    return {
      communicationModes: [
        { text: "SMS", value: "1" },
        { text: "Email", value: "2" },
        { text: "Both", value: "3" },
        { text: "No communication", value: "4" },
      ],
      covidSafetyOptions: [
        { text: "Vaccinated", value: "1" },
        { text: "PCR Test", value: "2" },
        { text: "None", value: "3" },
      ],
      checked: [],
      approve: [
        { text: "Auto approve", value: "AutoApprove", disabled: false },
        { text: "Allow 15 hours", value: "Allow24Hrs", disabled: false },
      ],
      loading: true,
      errored: false,
      alertMessage: {},
      lang: this.$lang.site_management,
      selectedData: [],
      model: {
        siteName: "",
        mode: "",
        companyName: "",
        covidSafety: 3,
        frequencyWeek: "",
      },
      selects: {
        simple: "Select",
      },
      companyName: [],
      editWorkTypeInput: '',
      edit_work_permit_template: '',
      editdocuments: [],
      editIndex: null,
      newWorkType: '',
      work_permit_template: '',
      workTypes: [],
      departmentName: "",
      documentName: [],
      departments: [],
      requiredDocument: [],
      siteId: null,
      approversName: [],
      approvers: [],
      modalData: {
        departmentIndex: null,
        levelKey: "",
        approverIndex: null,
        Name: "",
        EmailAddress: "",
        Password: "",
      },
      modalVisible: false,
      approverLevels: [
        { key: "level_one_approvers_ids", label: "Level 1 Approvers", keyName: 'level_one_approvers' },
        { key: "level_two_approvers_ids", label: "Level 2 Approvers", keyName: 'level_two_approvers' },
        { key: "level_three_approvers_ids", label: "Level 3 Approvers", keyName: 'level_three_approvers' },
      ],
      documentInput: [],
    };
  },
  computed: {
    ...mapGetters({
      login: "login",
    }),
    isCompanyAdmin() {
      return this.login && this.login.IsCompanyAdmin === true;
    },
    userCompanyID() {
      return this.login && this.login.CompanyID ? this.login.CompanyID : null;
    },
    getApproversNameByCompany() {
      if (this.selectedData.CompanyID == "") return [];
      return this.approvers.filter(approver => approver.CompanyID == this.selectedData.CompanyID);
    },
    allDocuments() {
      // Combine required documents and custom entries
      const customDocs = this.documentInput.filter(doc => 
        !this.requiredDocument.some(reqDoc => reqDoc.name === doc.name)
      );
      return [...this.requiredDocument, ...customDocs];
    }
  },
  watch: {
    editdocuments: {
      immediate: true,
      handler(newDocs) {
        if (newDocs && newDocs.length) {
          this.documentInput = newDocs.map(doc => 
            typeof doc === 'object' ? doc : { id: doc, name: doc }
          );
        }
      }
    }
  },
  mounted() {
    let self = this;
    this.getAllApproversList();
    this.getRequiredDocuments();
    this.$store.dispatch("viewSite", this.$route.params.id).then((response) => {
      if (response.status == 200) {
        this.selectedData = response.data;
        if (this.selectedData.SiteCommsPref) {
          this.model.mode = this.selectedData.SiteCommsPref;
        }
        if (response.data.Allow24Hrs) {
          this.checked.push("Allow24Hrs");
        }
        if (response.data.AutoApprove) {
          this.checked.push("AutoApprove");
        }
        if (response.data.StartDateBeforeX) {
          this.model.hours = response.data.StartDateBeforeX;
        }
        if (response.data.work_types) {
          this.workTypes = response.data.work_types.map(e => ({
            id: e.id,
            name: e.name,
            documentName: e.required_documents.map(doc => doc),
            work_permit_template: e.work_permit_template,
            actions: ''
          }));
        }
        if (response.data.departments.length) {
          const ids = response.data.departments.reduce((acc, department) => {
            acc[department.id] = this.approverLevels.reduce((approverAcc, level) => {
              approverAcc[level.key] = {
                ids: department[level.keyName].map(approver => (approver.ID)).flat(),
              };
              return approverAcc;
            }, {});
            return acc;
          }, {});

          this.departments = response.data.departments.map((department, index) => ({
            ...department,
            expanded: this.getInitialExpandedState(index),
            editing: true,
            ...ids[department.id]
          }));

        }
        if (response.data.ID) {
          this.siteId = response.data.ID;
        }
        this.$store.dispatch("companyList").then((response) => {
          if (response.status == 200) {
            this.companyName = response.data;
            
            // Set default company if user is company admin
            if (this.isCompanyAdmin && this.userCompanyID) {
              this.model.companyName = this.userCompanyID;
            } else {
              this.model.companyName = this.selectedData.CompanyID;
            }
            
            this.model.covidSafety = this.selectedData.CovidSafety;
            this.model.siteName = this.selectedData.Name;
            this.model.frequencyWeek = this.selectedData.FrequencyWeek;
            this.loading = false;
          } else {
            if (response.status == 404) {
              this.errored = true;
            } else {
              if (typeof response.data.message != "object") {
                this.alertMessage = {
                  type: 'danger',
                  message: response.data.message
                };
              } else {
                let array = new Array();
                for (let key of Object.keys(response.data.message)) {
                  let obj = response.data.message[key][0].includes("field")
                    ? key + "- " + response.data.message[key][0]
                    : response.data.message[key];
                  array.push(obj);
                }
                this.alertMessage = {
                  type: 'success',
                  message: array.join(", ")
                };
                setTimeout(function () {
                  self.alertMessage = {};
                }, 5000);
              }
            }
            this.loading = false;
          }
        });
      } else {
        if (response.status == 404) {
          this.errored = true;
        } else {
          if (typeof response.data.message != "object") {
            this.alertMessage = {
              type: 'danger',
              message: response.data.message
            };
          } else {
            let array = new Array();
            for (let key of Object.keys(response.data.message)) {
              let obj = response.data.message[key][0].includes("field")
                ? key + "- " + response.data.message[key][0]
                : response.data.message[key];
              array.push(obj);
            }
            this.alertMessage = {
              type: 'success',
              message: array.join(", ")
            };
            setTimeout(function () {
              self.alertMessage = {};
            }, 5000);
          }
        }
        this.loading = false;
        this.loading = false;
      }
    });
  },
  methods: {
    handleEnterPress(event) {
      const inputValue = event.target.value.trim().toLowerCase();
      
      // Compare existing document names from both arrays
      const existingNames = [
        ...this.requiredDocument.map(doc => doc.name.toLowerCase()),
        ...this.documentName.map(doc => (doc.name || doc).toLowerCase())
      ];
      
      const isDuplicate = existingNames.includes(inputValue);

      if (inputValue && !isDuplicate) {
        this.documentName.push(inputValue);
      } else if (isDuplicate) {
        this.$message.warning('This document name already exists');
      }
      event.target.value = '';
    },
    openApproverModal(depIndex, levelKey, approverIndex) {
      this.modalData = { departmentIndex: depIndex, levelKey, approverIndex, Name: "", EmailAddress: "", Password: "" };
      this.modalVisible = true;
    },
    saveApproverDetails() {
      const { departmentIndex, levelKey, approverIndex, Name, EmailAddress, Password } = this.modalData;

      if (!this.departments[departmentIndex][levelKey]) {
        this.$set(this.departments[departmentIndex], levelKey, []);
      }

      this.departments[departmentIndex][levelKey].push({
        Name,
        EmailAddress,
        Password,
      });
      this.validate(departmentIndex, levelKey);
      this.modalData = {
        departmentIndex: null,
        levelKey: "",
        approverIndex: null,
        Name: "",
        EmailAddress: "",
        Password: "",
      };
      this.modalVisible = false;
    },
    getAllApproversList() {
      let self = this;
      self.$store.dispatch('listOfApprovers')
        .then(response => {
          self.approvers = response;
        })
        .catch(error => {
          console.error('Error fetching approvers:', error);
        });
    },
    showDeleteModal(index) {
      this.editIndex = index.item.id;
      this.$bvModal.show('deleteWorkTypeModal');
    },
    handleApproverSelection(depIndex, levelKey) {
      this.departments[depIndex][levelKey].ids.map(id => ({ ID: id })) || [];
    },
    validate(depIndex, levelKey) {
      const level = this.departments[depIndex][levelKey];
      if (!level) return false;
      const hasIds = Array.isArray(level.ids) && level.ids.length > 0;
      const hasEmails = level.some(id => id.EmailAddress);
      return hasIds || hasEmails;
    },
    getWorkTypeList() {
      const self = this;
      self.$store.dispatch('listOfWorkTypeWithDocument')
        .then((response) => {
          if (response.status === 200) {

            self.workTypes = response.data
              .filter(e => e.site === self.siteId)
              .map(e => ({
                id: e.id,
                name: e.name,
                documentName: Array.isArray(e.required_documents)
                  ? e.required_documents.map(doc => doc)
                  : [],
                work_permit_template: e.work_permit_template,
                actions: ''
              }));
          } else {
            throw new Error('Failed to fetch work types.');
          }
        })
        .catch((error) => {
          console.error(error);
          self.alertMessage = {
            type: 'danger',
            message: 'An error occurred while fetching work types.'
          };
        });
    },
    getDepartments() {
      let self = this;
      self.$store.dispatch('listOfDepartments', self.siteId)
        .then((response) => {
          if (response.status === 200) {
            const ids = response.data.reduce((acc, department) => {
              acc[department.id] = self.approverLevels.reduce((approverAcc, level) => {
                approverAcc[level.key] = {
                  ids: department[level.keyName].map(approver => (approver.ID)).flat(),
                };
                return approverAcc;
              }, {});
              return acc;
            }, {});

            /*
             * Snapshot of departments that were not saved
             */
            const unSavedDepartments = self.departments.reduce((acc, department, index) => {
              if (!department.id) {
                acc[index] = department;
              }
              return acc;
            }, {});

            /*
             * Update departments with response data
             */
            self.departments = response.data.map((department, index) => ({
              ...department,
              expanded: this.getInitialExpandedState(index),
              editing: true,
              ...ids[department.id]
            }));

            /*
             * Add departments that were not saved to current array
             */
            Object.keys(unSavedDepartments).forEach(d => {
              const isAvailable = self.departments.some(dep => dep.name === unSavedDepartments[d].name);
              if (!isAvailable) {
                self.departments.splice(d, 0, unSavedDepartments[d]);
              }
            });
          } else {
            throw new Error('Failed to fetch departments.');
          }
        })
        .catch((error) => {
          console.error(error);
          self.alertMessage = {
            type: 'danger',
            message: 'An error occurred while fetching departments.'
          };
        });
    },
    closeDeleteModal() {
      this.$bvModal.hide('deleteWorkTypeModal');
    },
    addWorkType(e) {
      e.preventDefault();
      e.stopPropagation();
      const self = this;
      let data = {
        name: self.newWorkType,
        required_documents: self.documentName.map(doc => ({ name: doc.name || doc })),
        work_permit_template: self.work_permit_template,
        site: self.siteId,
      };
      if (self.newWorkType.trim()) {
        self.$store.dispatch("addWorkTypeWithDocument", data)
          .then((response) => {
            if (response.status === 200) {
              self.getWorkTypeList()
              self.newWorkType = '';
              self.work_permit_template = '';
              self.documentName = [];
            } else {
              throw new Error("Failed to add work type.");
            }
          })
          .catch((error) => {
            console.error(error);
            self.alertMessage = {
              type: 'danger',
              message: 'An error occurred while adding the work type.'
            };
          });
      } else {
        self.alertMessage = {
          type: 'danger',
          message: 'Please enter a valid work type.'
        }
      }
    },

    showEditModal(item, index) {
      this.editIndex = item.id;
      this.editWorkTypeInput = item.name;
      this.edit_work_permit_template = item.work_permit_template;
      this.editdocuments = [...item.documentName];
      this.documentInput = [];
      this.$bvModal.show('editWorkTypeModal');
    },
    handleEditEnterPress(event) {
      const inputValue = event.target.value.trim().toLowerCase();
    // Compare existing document names from both arrays
    const existingNames = [
      ...this.requiredDocument.map(doc => doc.name.toLowerCase()),
      ...this.documentInput.map(doc => (doc.name || doc).toLowerCase())
    ];
    const isDuplicate = existingNames.includes(inputValue);
    if (inputValue && !isDuplicate) {
      this.documentInput.push(inputValue);
    } else if (isDuplicate) {
      this.$message.warning('This document name already exists');
    }
    event.target.value = '';
    },
    removeDocument(index) {
      this.editdocuments.splice(index, 1);
    },
    confirmEditWorkType() {
      const self = this;
      if (self.editIndex !== null) {
        const documents = [
          ...self.editdocuments, 
          ...self.documentInput.map(doc => ( doc.name|| doc))
        ].filter((doc, index, self) => 
          index === self.findIndex(d => 
            (d.name || d).toLowerCase() === (doc.name || doc).toLowerCase()
          )
        );
        
        const data = {
          id: self.editIndex,
          name: self.editWorkTypeInput,
          work_permit_template: self.edit_work_permit_template,
          required_documents: documents.map(doc => {
            // If doc is an object with id, return id and name
            if (typeof doc === 'object' && doc.id) {
              return {
                id: doc.id,
                name: doc.name
              };
            }
            // If doc is a string or object without id, return only name
            return {
              name: typeof doc === 'object' ? doc.name : doc
            };
          }),
          site: self.siteId,
        };
        
        
        self.$store.dispatch('updateWorkTypeWithDocument', data)
          .then((response) => {
            if (response.status === 200) {
              self.getWorkTypeList()
              self.alertMessage = { type: 'success', message: response.data.message || 'Work type updated successfully!' };
            } else {
              throw new Error('Failed to update work type.');
            }
          })
          .catch((error) => {
            console.error(error);
            self.alertMessage = { type: 'danger', message: 'An error occurred while updating the work type.' };
          })
          .finally(() => {
            self.closeEditModal();
          });
      } else {
        self.alertMessage = { type: 'danger', message: 'No work type selected for editing.' };
      }
    },

    closeEditModal() {
      this.editWorkTypeInput = '';
      this.edit_work_permit_template = '';
      this.editdocuments = [];
      this.editIndex = null;
      this.$bvModal.hide('editWorkTypeModal');
    },
    deleteWorkType() {

      this.$store.dispatch('deleteWorkTypeWithDocument', this.editIndex)
        .then((response) => {
          if (response.status === 200) {
            this.getWorkTypeList()
          } else {
            throw new Error('Failed to delete work type.');
          }
        })
        .catch((error) => {
          console.log(error, 'error')
          this.alertMessage = { type: 'danger', message: 'An error occurred while deleting the work type.' };
        });
    },

    editDepartment(depIndex) {

      this.departments[depIndex].editing = true;
    },

    getApproverIds(depIndex, type, method) {
      const self = this;
      let ids;
      try {

        ids = [...self.departments[depIndex][type.key].ids.map(id => ({ ID: id }))];
        self.departments[depIndex][type.keyName].map(newApprovers => {
          if (!newApprovers.ID) {
            ids.push({ ...newApprovers });
          }
        });

        if (depIndex === 0) {

        }
      } catch (error) {

      }
      return ids;
    },
    saveDepartment(depIndex, id) {
      const self = this;
      let data = {
        name: self.departments[depIndex].name,
        site: self.siteId,
        level_one_approvers: self.getApproverIds(depIndex, self.approverLevels[0], id ? 'update' : 'add'),
        level_two_approvers: self.getApproverIds(depIndex, self.approverLevels[1], id ? 'update' : 'add'),
        level_three_approvers: self.getApproverIds(depIndex, self.approverLevels[2], id ? 'update' : 'add'),
      }
      let methods = "addDepartment"
      let payload = {
        data: data
      }
      if (id) {
        methods = "updateDepartment"
        payload = {
          data: data,
          id: id,
        };
      }
      if (self.departments[depIndex].name) {

        self.$store.dispatch(methods, payload)
          .then((response) => {
            if (response.status === 200) {
              self.getDepartments()
              self.getAllApproversList();
              self.departmentName = '';
            } else {
              throw new Error(response.data.message.message[0]);
            }
          })
          .catch((error) => {
            console.error(error);
            self.alertMessage = {
              type: 'danger',
              message: `${error}`
            };
          });
        self.departmentName = '';
        self.alertMessage = {
          type: 'success',
          message: `Department saved successfully!`
        };
      } else {
        self.alertMessage = {
          type: 'danger',
          message: `Please enter a valid Department.`
        };
      }
    },
    removeDepartment(department, depIndex) {
      if (!department.id) {
        this.departments.splice(depIndex, 1);
        return;
      }
      this.$store.dispatch('deleteDepartment', department.id)
        .then((response) => {
          if (response.status === 200) {
            this.getDepartments();
            this.closeDeleteModal();
          } else {
            throw new Error('Failed to delete work type.');
          }
        })
        .catch((error) => {
          this.alertMessage = { type: 'danger', message: 'An error occurred while deleting the work type.' };
        });

    },
    addDepartment(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.departmentName.trim()) {
        const ids = this.approverLevels.reduce((acc, level) => {
          acc[level.key] = { ids: [] };
          return acc;
        }, {});
        this.departments.push({
          name: this.departmentName,
          expanded: true,
          editing: true,
          level_one_approvers: [],
          level_two_approvers: [],
          level_three_approvers: [],
          ...ids,
        });

        this.departmentName = '';
        self.alertMessage = {
          type: 'success',
          message: `Work type added successfully!`
        };
      } else {
        self.alertMessage = {
          type: 'danger',
          message: `Please enter a valid work type.`
        };
      }
    },
    toggleDepartment(index) {

      this.departments[index].expanded = !this.departments[index].expanded;
    },
    addEmail(depIndex, levelKey) {
      this.departments[depIndex][levelKey].emails.push("");
    },
    removeEmail(depIndex, levelKey, emailDataIndex) {
      this.departments[depIndex][levelKey].splice(emailDataIndex, 1);
    },
    addApprover(depIndex, levelKey) {
      this.departments[depIndex][levelKey].push({ ID: null });
    },
    removeApprover(depIndex, levelKey, approverIndex) {
      this.departments[depIndex][levelKey].splice(approverIndex, 1);
    },
    checkHours(index, evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (parseInt(this.model.hours) == 0) {
        this.model.hours = "";
        evt.preventDefault();
        return true;
      }
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    onSubmit() {
      this.loading = true;
      let data = {
        Name: this.model.siteName,
        CompanyID: this.model.companyName,
        id: this.$route.params.id,
        CovidSafety: this.model.covidSafety,
        FrequencyWeek: this.model.frequencyWeek,
      };
      data.AutoApprove = this.checked.includes("AutoApprove");
      data.Allow24Hrs = this.checked.includes("Allow24Hrs");
      data.SiteCommsPref = this.model.mode;
      data.StartDateBeforeX = this.model.hours ? this.model.hours : null;
      data.work_types = this.workTypes.map(workType => ({
        name: workType.name,
        required_documents: workType.documentName.map(doc => ({ name: doc })),
        work_permit_template: workType.work_permit_template
      }));
      data.departments = this.departments.map((department, depIndex) => ({
        name: department.name,
        level_one_approvers: this.getApproverIds(depIndex, this.approverLevels[0]),
        level_two_approvers: this.getApproverIds(depIndex, this.approverLevels[1]),
        level_three_approvers: this.getApproverIds(depIndex, this.approverLevels[2]),
      }))
      // this.model.mode
      this.$store.dispatch("updateSite", data).then((response) => {
        if (response.status == 200) {
          this.flash({ message: response.data.message, variant: "success" });
          this.$router.push({ name: "siteManagementList" });
        } else {
          if (typeof response.data.message != "object") {
            this.alertMessage = { type: 'danger', message: response.data.message };
          } else {
            var array = new Array();
            for (let key of Object.keys(response.data.message)) {
              let obj = response.data.message[key][0].includes("field")
                ? key + "- " + response.data.message[key][0]
                : response.data.message[key];
              array.push(obj);
            }
            this.alertMessage = { type: 'success', message: array.join(", ") };
          }

          this.type = "danger";
          this.loading = false;
        }
      });
      // }
    },
    async getRequiredDocuments() {
      try {
        const response = await this.$store.dispatch("fetchDocuments");
        if (response.data) {
          this.requiredDocument = response.data;
        }
      } catch (error) {
        console.error('Error fetching documents:', error);
      }
    },
    getInitialExpandedState(index) {
      // You can customize this logic based on your needs
      return index === 0; // Only first department will be expanded by default
    },
    handleDocumentSelection(selectedDocs) {
    // Get all existing names from requiredDocument
    const existingNames = this.requiredDocument.map(doc => doc.name.toLowerCase());
    
    // Filter out duplicates from selection
    const uniqueDocs = selectedDocs.filter(doc => 
      !existingNames.includes((doc.name || doc).toLowerCase())
    );
    
    this.documentName = uniqueDocs;
    
  }
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

.modal-header {
  padding-bottom: 0;
}

.gap-1 {
  gap: 0.25rem;
}

.el-tag {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
